import { render } from "./A000000.vue?vue&type=template&id=921b0c9e&scoped=true"
import script from "./A000000.vue?vue&type=script&lang=js"
export * from "./A000000.vue?vue&type=script&lang=js"

import "./A000000.vue?vue&type=style&index=0&id=921b0c9e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921b0c9e"]])

export default __exports__